import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from './Icon';
import s from './Glyph.module.css';
/**
 * A section's icon on a rounded square, as in macOS settings — monochrome, to
 * suit the black-and-white panel. `active` inverts it (the open section).
 */
export function Glyph({ icon, text, size = 'sm', active = false, }) {
    const px = size === 'lg' ? 22 : size === 'md' ? 16 : 14;
    return (_jsx("span", { className: s.glyph, "data-size": size, "data-active": active || undefined, "aria-hidden": "true", children: text ? _jsx("span", { className: s.text, children: text }) : icon && _jsx(Icon, { name: icon, size: px }) }));
}
